import { render, staticRenderFns } from "./remittanceApplyBox.vue?vue&type=template&id=778ed506&scoped=true"
import script from "./remittanceApplyBox.vue?vue&type=script&lang=js"
export * from "./remittanceApplyBox.vue?vue&type=script&lang=js"
import style0 from "./remittanceApplyBox.vue?vue&type=style&index=0&id=778ed506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778ed506",
  null
  
)

export default component.exports